// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rcmL9","name":"Header_name__2f1rG","birthday":"Header_birthday__39uHY","skeleton":"Header_skeleton__2kNsl"};